import { MenuItem, TextField, Button } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { closeModal, openModal } from '../../../../redux/modals/action';
import Modal from '../../../layout/modal/Modal';
import styles from './AddProjectsModal.module.scss';
import Chip from '@material-ui/core/Chip';
import CustomButton from '../../../layout/customButton/CustomButton';
import { addProjectToUser } from '../../../../api/UserManagement/addProjectToUser.api.js';
import { getProjectById } from '../../../../api/UserManagement/getProjectById.api';
const AddProjectsModal = ({
	show,
	closeModal,
	projects,
	openModal,
	projectsList,
	setProjectsList,
	defaultRole,
	userIdClicked,
	userSelected,
	projectListById,
	clearChipData,
}) => {
	const [chipData, setChipData] = useState([]);
	const [select, setSelect] = useState();

	useEffect(() => {
		//check if there is a list of project
		if (projectListById) {
			setChipData(projectListById);
		}
	}, [projectListById]);

	useEffect(() => {
		if (clearChipData) {
			setChipData([]);
		}
	}, [clearChipData, show]);

	const handleClose = () => {
		closeModal('addProjects');
		setChipData([]);
	};

	const handleDelete = (chipToDelete) => () => {
		setChipData((chips) =>
			chips.filter((chip) => chip.key !== chipToDelete.key)
		);
	};

	const handleSelect = (e) => {
		console.log(e.currentTarget.dataset.key);
		setSelect(e.target.value);

		console.log('e.target.value', e.target.value);

		var keyFound = false;

		chipData.map((chip) => {
			if (chip.key === e.currentTarget.dataset.key) {
				keyFound = true;
			}
		});

		if (keyFound !== true) {
			setChipData([
				...chipData,
				{
					key: e.currentTarget.dataset.key,
					label: e.target.value,
					role: '',
				},
			]);
		}
	};

	const handleSave = () => {
		openModal('addUserMgmt');
		setProjectsList(chipData);

		if (userSelected) {
			addProjectToUser(userIdClicked, chipData);
		}
	};
	return (
		<div className={styles.wrapper}>
			<Modal show={show} close={handleClose} title='Projects'>
				<div className={styles.addProjectsWrapper}>
					<div className={styles.dropdown}>
						<TextField
							select
							SelectProps={{
								style: {
									backgroundColor: 'none',

									'&.MuiSelect-select:focus': {
										backgroundColor: 'white',
									},
								},
								MenuProps: {
									MenuListProps: {
										disablePadding: true,
									},
								},
							}}
							// value={select}
							variant='outlined'
							fullWidth
							onChange={(e) => handleSelect(e)}
						>
							{projects?.map((project) => (
								<MenuItem
									className={styles.idTypeItem}
									value={project.companyName}
									data-key={project.id}
								>
									{project?.companyName}
								</MenuItem>
							))}
						</TextField>
					</div>
					<div className={styles.content}>
						{chipData?.map((data) => {
							return (
								<li key={data.key}>
									<Chip
										label={data.label}
										onDelete={handleDelete(data)}
									/>
								</li>
							);
						})}
					</div>
				</div>

				<div className={styles.actions}>
					<Button className={styles.cancel_btn} onClick={handleClose}>
						Cancel
					</Button>
					<CustomButton
						type={'submit'}
						width={166}
						height={42}
						onClick={handleSave}
					>
						Save
					</CustomButton>
				</div>
			</Modal>
		</div>
	);
};

const mapStateToProps = (state) => ({
	projects: state.userManagement.projects,
	userIdClicked: state.userManagement.userById.id,
	projectListById: state.userManagement.projectList,
});

export default connect(mapStateToProps, { openModal, closeModal })(
	AddProjectsModal
);
